const html = require('choo/html')

const PanelElement = require('../elements/panel.js')
const TutorialPanel = require('./tutorial-panel.js')
module.exports = function CodePanel (state, emit) {
  let imgSrc = 'graphics/placeholder_code_image.png'
//  return null
  return PanelElement({
    color: 'purple',
    size: 'small',
    children: []
  })
}
